export const textChange = ({ target: { name, value } }, setFormValue) => setFormValue({ name, value })
export const fileChange = ({ target: { name, files } }, setFormValue) => setFormValue({ name, value: files[0] })

export const onBlur = ({ target: { name } }, setTouched) => {
    setTouched((prevState) => {
        if (!prevState[name]) return { ...prevState, ...{ [name]: true } }
        else return prevState;
    })
}

export const formData = (formValue) => {
    let data = new FormData();
    for (const [key, value] of Object.entries(formValue)) {
        data.append(key, value)
    }

    return data;
}

const handleReducer = (state, { name, value, type = 'CHANGE' }) => {
    if (type === 'CHANGE') return { ...state, ...{ [name]: value } }
    else if (['INITIAL_SET', 'RESET', 'SET'].includes(type)) return value
    else return state;
}

export default handleReducer;